// Stores
import { useGlobalStore } from '@/stores/global';
import { useHeaderStore } from '@/stores/header';
import { useFooterStore } from '@/stores/footer';
// Composables
import { useHoursStore } from '~/stores/hours';

export const updateGlobals = async () => {
    // Make the API calls
    const { data: global } = await useAsyncData('global-data', () => $fetch('/api/global-data'));
    const { data } = unref(global);
    // Update the stores
    if (data) {
        useGlobalStore().init(data);
        useHeaderStore().init(data.header);
        useFooterStore().init(data.footer);
        const hours = {
            base: data.centerHours,
            special: data.specialHours,
            message: data.hoursMessage,
        };
        useHoursStore().init(hours);
    }
    return data;
};
